import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { formatCurrency } from 'ddc-intl';
import { Collapse } from 'react-bootstrap';
import { useLabels } from 'wsm-common-data';
import { trackEvent, togglePackageOptionsEvent } from '../utils/analytics';

const DealerAccessories = (props) => {
	const labels = useLabels();
	const [open, setOpen] = useState(false);

	const toggleOptions = () => {
		const { windowId, widgetName } = props.widgetInfo;
		setOpen((prevState) => !prevState);
		trackEvent(togglePackageOptionsEvent(widgetName, windowId));
	};

	const renderOptions = (
		accessories = [],
		indentStyles = '',
		showPricing = false,
		locale = 'en_US',
		hasLink = false,
		buttonLabel
	) => {
		const linkVisibility = open ? 'hidden' : '';
		const collapseLink = hasLink ? (
			<li className={`${linkVisibility}`}>
				<button
					key="button"
					type="button"
					onClick={toggleOptions}
					className="text-link"
				>
					{buttonLabel}
				</button>
			</li>
		) : null;
		return (
			<ul
				className={`text-muted list-unstyled list-spaced ${indentStyles}`}
			>
				{accessories.map(({ name, price }) => {
					const displayPrice =
						showPricing && price !== 0 ? (
							<strong className="option-price ml-auto pl-5">
								{formatCurrency(price, locale)}
							</strong>
						) : null;
					return (
						<li key={name}>
							<div className="d-flex">
								<span className="option-title text-muted">
									{name}
								</span>
								{showPricing ? displayPrice : null}
							</div>
						</li>
					);
				})}
				{collapseLink}
			</ul>
		);
	};

	const { deviceType, accessories, showPricing, locale } = props;
	if (accessories.length === 0) {
		return null;
	}

	const indentStyles = deviceType === 'DESKTOP' ? 'ml-6' : '';

	// if price doesn't exist, make name column full width so as to not wrap early
	let renderedOptions = null;
	let additionalOptions = null;

	if (accessories.length < 5) {
		// render all options if 4 or less
		renderedOptions = renderOptions(
			accessories,
			indentStyles,
			showPricing,
			locale
		);
	} else {
		// render first 3 options and have link to show the rest
		const firstThreeOptions = accessories.slice(0, 3);
		const remaindingOptions = accessories.slice(3);
		renderedOptions = renderOptions(
			firstThreeOptions,
			indentStyles,
			showPricing,
			locale,
			true,
			labels.get('SHOW_ALL_PACKAGE_ITEMS')
		);
		const renderedRemaindingOptions = renderOptions(
			remaindingOptions,
			indentStyles,
			showPricing,
			locale
		);
		additionalOptions = [
			<Collapse key="collapse" in={open}>
				{renderedRemaindingOptions}
			</Collapse>
		];
	}
	return (
		<div className="mb-3">
			<strong className="mb-4 d-flex">
				{labels.get('DEALER_INSTALLED_ACCESSORIES')}
			</strong>
			{renderedOptions}
			{additionalOptions}
		</div>
	);
};

DealerAccessories.defaultProps = {
	locale: 'en_US',
	accessories: [],
	widgetInfo: {
		windowId: 'packages-options1',
		widgetName: 'ws-packages-options'
	}
};

DealerAccessories.propTypes = {
	deviceType: PropTypes.string.isRequired,
	locale: PropTypes.string,
	accessories: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
			price: PropTypes.number.isRequired
		})
	),
	showPricing: PropTypes.bool.isRequired,
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string,
		widgetName: PropTypes.string
	})
};

export default DealerAccessories;
